import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"

import { FORM_URL } from 'app/@common/constants'


export default function SelectPax({ ...props }) {
    const myProps = {
        urlAjax: FORM_URL.PAX,
        isMulti: true,
        icon: { icon: 'user' },
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}